/**
 * Constante de datos de entorno para usar a traves de la app
 */
export const env = {
    /**
     * Url de la API
     */
    //apiUrl :'https://devapi.fdscolbun.org',
    //apiUrl:'http://15.235.186.11:8000'// Api Testing
    //apiUrl:'http://localhost:8000'
    // apiUrl:'http://142.4.203.83:8000'
    apiUrl:'https://devapi.mca.cl'
}
